import { render, staticRenderFns } from "./area_select.vue?vue&type=template&id=0aba14b0&scoped=true&"
import script from "./area_select.vue?vue&type=script&lang=js&"
export * from "./area_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba14b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aba14b0')) {
      api.createRecord('0aba14b0', component.options)
    } else {
      api.reload('0aba14b0', component.options)
    }
    module.hot.accept("./area_select.vue?vue&type=template&id=0aba14b0&scoped=true&", function () {
      api.rerender('0aba14b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/area_select.vue"
export default component.exports